<template>
  <div class="search_input">
    <el-input v-model="localName" clearable @keyup.enter="handleSearch" />
    <el-icon :size="iconSize" @click="handleSearch">
      <search />
    </el-icon>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch } from "vue";
import { Search } from "@element-plus/icons";

const props = defineProps({
  modelValue: { type: String, default: "" },
  iconSize: { type: Number, default: 20 },
});

const emit = defineEmits(["update:modelValue", "search"]);

const localName = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newVal) => (localName.value = newVal)
);
watch(localName, (newVal) => emit("update:modelValue", newVal));

const handleSearch = () => emit("search");
</script>

<style scoped lang="scss">
.search_input {
  display: flex;
  align-items: center;

  :deep(.el-icon) {
    margin-left: 5px;
    cursor: pointer;
  }

  :deep(.el-input__wrapper) {
    width: 266px;
    height: 38px;
    background-color: var(--ux-surface-muted);
    border: 0;
    outline: none;
    padding: 0 20px;
    opacity: 0.5;
    align-items: center;
    border-radius: 19px;
    box-shadow: 0 0 0 0.01rem
      var(--el-input-border-color, var(--el-border-color)) inset;
    cursor: text;
    display: inline-flex;
    flex-grow: 1;
    justify-content: center;
    transform: translateZ(0);
    transition: var(--el-transition-box-shadow);
  }

  :deep(.el-input__inner) {
    color: var(--ux-text-primary);
  }

  :deep(.el-input .el-input__clear, .el-input .el-input__password) {
    color: var(--ux-text-primary);
  }
}
</style>
